const fnolState = {

    popup: {
        fullPageLoadingCount: 0
    }

}
export default fnolState
